module.exports = __webpack_public_path__ + "static/media/rarewaves.e764e8ee.png";